import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import CreateIcon from '@material-ui/icons/Create'
import PlaceIcon from '@material-ui/icons/Place'
import LinearScaleIcon from '@material-ui/icons/LinearScale'
import BackspaceOutlinedIcon from '@material-ui/icons/BackspaceOutlined'
import PanoramaFishEyeIcon from '@material-ui/icons/PanoramaFishEye'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'
import EraserIcon from './eraserIcon'
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import LooksOneRoundedIcon from '@material-ui/icons/LooksOneRounded'
import LooksTwoRoundedIcon from '@material-ui/icons/LooksTwoRounded'
import Looks3RoundedIcon from '@material-ui/icons/Looks3Rounded'
import Looks4RoundedIcon from '@material-ui/icons/Looks4Rounded'
import { connect } from 'react-redux'
import { instrumentsAction } from '../../../redux/actions/instruments'
import {
  removeLastItemAction,
  addMarkAction,
  removeTempMarkAction,
} from '../../../redux/actions/coordinates'
import SaveIcon from '@material-ui/icons/Save'
import { notify } from 'react-notify-toast'
import { getAllMarksForMapAction } from '../../../redux/actions/existingCoords'
import style from './index.module.scss'
import {
  openColorPickerAction,
  closeColorPickerAction,
} from '../../../redux/actions/colorpicker'
import Tooltip from '@material-ui/core/Tooltip'
import {
  isInvalidIOSSize,
  calculateIOSCanvasSize,
  replaceCoordinates,
} from '../../../helpers/Canvas/size'
import {hideHelperAction} from "../../../redux/actions/auth";

const useStyles = makeStyles((theme) => ({
  toggleContainer: {
    position: 'relative',
    margin: theme.spacing(2, 0),
  },
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
    border: 'transparent',
  },
  button: {
    position: 'relative',
    color: 'rgba(0, 0, 0, 0.38)',
    height: '9vw',
    width: '9vw',
    maxHeight: '48px',
    maxWidth: '48px',
    backgroundColor: 'white',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    margin: '1px',
    '&:hover': {
      backgroundColor: '#ebebff',
    },
    '&:active': {
      backgroundColor: '#ebebff',
    },
  },
  active: {
    backgroundColor: '#ebebff',
  },
  disabled: {
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: 'white',
    },
    '&:active': {
      backgroundColor: 'white',
    },
  },
  white: {
    color: 'white',
  },
  secondary: {
    color: '#313131',
  },
  info: {
    backgroundColor: '#313131',
    '&:hover': {
      backgroundColor: '#808080',
    },
  },
  dn: {
    display: 'none',
  },
  center: {
    position: 'relative',
    left: '6px',
  },
  guide: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    position: 'absolute',
    top: '-60px',
    left: '14px',
    padding: '10px',
    borderRadius: '5px',
  },
  guidePos: {
    width: '90vw',
    maxWidth: '360px',
    top: '-101px',
  },
  guidePos2: {
    top: '-82px',
  },
  guideText: {
    margin: '0 10px',
    fontWeight: '600',
    textTransform: 'uppercase',
    fontSize: '15px'
  },
  next: {
    backgroundColor: '#313131',
    color: 'white',
    cursor: 'pointer',
    marginRight: '30px',
    textTransform: 'uppercase',
    lineHeight: 2,
  },
  close: {
    border: 'none',
    backgroundColor: 'white',
    cursor: 'pointer',
    position: 'absolute',
    right: '0',
    top: '5px',
    textTransform: 'uppercase',
    lineHeight: 2,
  },
  closeIcon: {
    color: '#313131',
    fontSize: '14px',
  },
  overlay: {
    zIndex: '2',
    backgroundColor: 'rgba(0, 0, 0, 0.38)',
    height: 'calc(100% + 2px)',
    width: 'calc(100% + 2px)',
    position: 'absolute',
    left: '-1px',
    top: '-1px',
  },
}))

const DrawerInstruments = ({
  instrumentType,
  instrumentsAction,
  removeLastItemAction,
  addMarkAction,
  newCoords,
  removeTempMarkAction,
  map,
  temp_id,
  color,
  opened,
  openColorPickerAction,
  closeColorPickerAction,
  instrument,
  user,
  submissionId,
                             show_helper,
                             hideHelperAction,
}) => {
  const classes = useStyles()
  const DEFAULT_INSTRUMENT = 'grabbing'
  const [isDrawerOpen, setIsDrawerOpen] = useState(true)
  const [isHelperShow, setIsHelperShow] = useState(false)
  const [step, setStep] = useState(1)

  useEffect(() => {
    !show_helper && setIsHelperShow(true)
  }, [user])

  const handleToggleDrawInstruments = () => {
    setIsDrawerOpen(!isDrawerOpen)
    setIsHelperShow(false)
    setStep(1)
  }

  const handleHelpOpen = () => {
    setIsHelperShow(true)
    setIsDrawerOpen(true)
  }

  const handleHelpClose = () => {
    setIsHelperShow(false)
    setStep(1)
    hideHelperAction(true);
  }

  const handleNextStep = () => setStep(step + 1);


  const handleChangeInstrumentsType = (e, value) => {
    console.log(e, value)
    if (
      value !== 'close' &&
      value !== 'help' &&
      !user?.loading &&
      !user?.me?.access_token
    ) {
      alertHandler('not_authourized')
      return
    } else if (value === instrument) {
      return instrumentsAction(DEFAULT_INSTRUMENT)
    } else if (value) {
      if (value === 'close' || value === 'help') return
      if (value === 'back') {
        let copy = JSON.parse(JSON.stringify(newCoords))
        const lastItem = copy.splice(-1, 1)
        if (lastItem && lastItem[0] && lastItem[0].id) {
          removeTempMarkAction(lastItem[0].id)
        } else {
          removeLastItemAction()
        }
        return instrumentsAction(DEFAULT_INSTRUMENT)
      }
      if (value === 'save') {
        const filteredData = newCoords
        const elementsArray = []
        const invalidIOSSize = isInvalidIOSSize(map.width, map.height)
        const mapSize = { width: Number(map.width), height: Number(map.height) }
        const calculatedSize = invalidIOSSize
          ? calculateIOSCanvasSize(map.width, map.height)
          : null
        const replaceCoords = (c) =>
          replaceCoordinates(
            mapSize.width,
            mapSize.height,
            calculatedSize.width,
            calculatedSize.height,
            c,
          )

        filteredData &&
          filteredData.map((element) => {
            let obj

            if (element.type === 'point') {
              obj = { meta: {} }
              const coords = invalidIOSSize
                ? replaceCoords([element.x, element.y])
                : [element.x, element.y]
              obj.meta.type = element.type
              obj.meta.radius = element.radius
              obj.meta.color = element.color
              obj.meta.x = coords[0]
              obj.meta.y = coords[1]
            }

            if (element.type === 'line') {
              obj = { meta: {} }
              obj.meta.type = element.type
              obj.meta.color = element.color
              obj.meta.array = invalidIOSSize
                ? replaceCoords(element.coords)
                : element.coords
            }

            if (element.type === 'square') {
              obj = { meta: {} }
              obj.meta.type = element.type
              obj.meta.color = element.color
              obj.meta.array = invalidIOSSize
                ? replaceCoords(element.coords)
                : element.coords
            }

            if (element.type === 'circle') {
              obj = { meta: {} }
              obj.meta.type = element.type
              obj.meta.color = element.color
              obj.meta.array = invalidIOSSize
                ? replaceCoords(element.coords)
                : element.coords
            }

            if (element.type === 'brush') {
              obj = { meta: {} }
              obj.meta.type = element.type
              obj.meta.color = element.color
              obj.meta.array = invalidIOSSize
                ? replaceCoords(element.coords)
                : element.coords
            }

            if (obj) {
              if (element.id) {
                obj.id = element.id
              }
              elementsArray.push(obj)
            }
            return element
          })

        const data = {
          temp_id: `${+temp_id}`,
          map_id: map.id,
          items: elementsArray,
        }

        if (submissionId) {
          data.submission_id = submissionId
        }

        instrumentsAction(DEFAULT_INSTRUMENT)

        if (data.items.length > 0) {
          if (filteredData.filter((el) => el.type === 'point').length === 0) {
            return alertHandler('point_required')
          }
          console.log('alertHandler')

          return addMarkAction(data, alertHandler)
        } else return alertHandler('empty')
      }
      instrumentsAction(value)
    }
  }

  const alertHandler = (type) => {
    let errorColor = { background: '#f44336', text: '#FFFFFF' }
    let successColor = { background: '#1ec30e', text: '#FFFFFF' }
    let infoColor = { background: '#fff3cd', text: '#000' }
    if (type === 'success') {
      notify.show(
        'Submitted successfully, pending approval. Thank you for your contribution!',
        'custom',
        3000,
        successColor,
      )
    }
    if (type === 'empty') {
      notify.show('Nothing to save', 'custom', 3000, errorColor)
    }
    if (type === 'not_authourized') {
      notify.show('Please login to edit the map.', 'custom', 3000, errorColor)
    }
    if (type === 'error') {
      notify.show('Error occurred', 'custom', 3000, errorColor)
    }
    if (type === 'point_required') {
      notify.show(
        'Please place the Pin Drop Marker on the map to leave notes.',
        'custom',
        5000,
        infoColor,
      )
    }
  }

  const colorClickHandler = (e) => {
    e.stopPropagation()
    if (opened) {
      closeColorPickerAction()
    } else {
      openColorPickerAction()
    }
  }

  return (
    <React.Fragment>
      <div className={classes.toggleContainer}>
        {isHelperShow && (
          <div
            className={`${classes.guide} ${
              step !== 1 && step !== 3 && classes.guidePos
            } ${step === 2 && classes.guidePos2}`}
          >
            {step === 1 && (
              <>
                <LooksOneRoundedIcon className={classes.secondary} />
                <p className={classes.guideText}>Draw areas (optional) or simply drop a pin marker</p>
              </>
            )}
            {step === 2 && (
              <>
                <LooksTwoRoundedIcon className={classes.secondary} />
                <p className={classes.guideText}>
                  Zoom in to your map area, select pin marker and drop on map, enter notes
                </p>
              </>
            )}
            {step === 3 && (
              <>
                <Looks3RoundedIcon className={classes.secondary} />
                <p className={classes.guideText}>
                  Click here to undo prior steps
                </p>
              </>
            )}
            {step === 4 && (
              <>
                <Looks4RoundedIcon className={classes.secondary} />
                <p className={classes.guideText}>
                  Click Save after pin markers dropped and notes entered
                </p>
              </>
            )}
            <button
              className={classes.next}
              onClick={step === 3 ? handleHelpClose : handleNextStep}
            >
              {step === 3 ? 'close' : 'next'}
            </button>
            <button className={classes.close} onClick={handleHelpClose}>
              <CloseOutlinedIcon className={classes.closeIcon} />
            </button>
          </div>
        )}
        <ToggleButtonGroup
          value={instrumentType}
          exclusive
          onChange={handleChangeInstrumentsType}
          aria-label="text alignment"
          className={classes.root}
        >
          <Tooltip
            title={isDrawerOpen ? 'Close' : 'Open'}
            placement="top-start"
            arrow
          >
            <ToggleButton
              value="close"
              onClick={handleToggleDrawInstruments}
              className={`${classes.button} ${classes.info}`}
            >
              {isDrawerOpen ? (
                <CloseOutlinedIcon className={classes.white} />
              ) : (
                <ArrowBackIosIcon
                  className={`${classes.white} ${classes.center}`}
                />
              )}
            </ToggleButton>
          </Tooltip>
          <Tooltip title="Square" placement="top-start" arrow>
            <ToggleButton
              value="square"
              className={`${classes.button} ${
                instrument === 'square' ? classes.active : classes.disabled
              } ${!isDrawerOpen && classes.dn}`}
            >
              {isHelperShow && (step === 2 || step === 3 || step === 4) && (
                <div className={classes.overlay}></div>
              )}
              <CheckBoxOutlineBlank />
            </ToggleButton>
          </Tooltip>
          <Tooltip title="Circle" placement="top-start" arrow>
            <ToggleButton
              value="circle"
              className={`${classes.button} ${
                instrument === 'circle' ? classes.active : classes.disabled
              } ${!isDrawerOpen && classes.dn}`}
            >
              {isHelperShow && (step === 2 || step === 3 || step === 4) && (
                <div className={classes.overlay}></div>
              )}
              <PanoramaFishEyeIcon />
            </ToggleButton>
          </Tooltip>
          <Tooltip title="Brush" placement="top-start" arrow>
            <ToggleButton
              value="brush"
              className={`${classes.button} ${
                instrument === 'brush' ? classes.active : classes.disabled
              } ${!isDrawerOpen && classes.dn}`}
            >
              {isHelperShow && (step === 2 || step === 3 || step === 4) && (
                <div className={classes.overlay}></div>
              )}
              <CreateIcon />
            </ToggleButton>
          </Tooltip>
          <Tooltip title="Line" placement="top-start" arrow>
            <ToggleButton
              value="line"
              className={`${classes.button} ${
                instrument === 'line' ? classes.active : classes.disabled
              } ${!isDrawerOpen && classes.dn}`}
            >
              {isHelperShow && (step === 2 || step === 3 || step === 4) && (
                <div className={classes.overlay}></div>
              )}
              <LinearScaleIcon />
            </ToggleButton>
          </Tooltip>
          <Tooltip title="Drop Marker" placement="top-start" arrow>
            <ToggleButton
              value="point"
              className={`${classes.button} ${
                instrument === 'point' ? classes.active : classes.disabled
              } ${!isDrawerOpen && classes.dn}`}
            >
              {isHelperShow && (step === 1 || step === 3 || step === 4) && (
                <div className={classes.overlay}></div>
              )}
              <PlaceIcon />
            </ToggleButton>
          </Tooltip>
          <Tooltip title="Eraser" placement="top-start" arrow>
            <ToggleButton
              value="eraser"
              className={`${classes.button} ${
                instrument === 'eraser' ? classes.active : classes.disabled
              } ${!isDrawerOpen && classes.dn}`}
            >
              {isHelperShow && <div className={classes.overlay}></div>}
              <EraserIcon />
            </ToggleButton>
          </Tooltip>
          <Tooltip title="Color Picker" placement="top-start" arrow>
            <ToggleButton
              value="colorpicker"
              className={`${classes.button} ${
                instrument === 'colorpicker' ? classes.active : classes.disabled
              } ${!isDrawerOpen && classes.dn}`}
            >
              {isHelperShow && <div className={classes.overlay}></div>}
              <div
                id="color-btn"
                className={style.Color}
                style={{ background: color }}
                onClick={(e) => colorClickHandler(e)}
              ></div>
            </ToggleButton>
          </Tooltip>
          <Tooltip title="Undo Last" placement="top-start" arrow>
            <ToggleButton
              value="back"
              className={`${classes.button} ${
                instrument === 'back' ? classes.active : classes.disabled
              } ${!isDrawerOpen && classes.dn}`}
            >
              {isHelperShow && step !== 3 && (
                <div className={classes.overlay}></div>
              )}
              <BackspaceOutlinedIcon />
            </ToggleButton>
          </Tooltip>
          {/* <Tooltip title="Save and Submit" placement="top-start" arrow>
            <ToggleButton
              value="save"
              className={`${classes.button} ${
                instrument === 'save' ? classes.active : classes.disabled
              } ${!isDrawerOpen && classes.dn}`}
            >
              {isHelperShow && (step === 1 || step === 2 || step === 3) && (
                <div className={classes.overlay}></div>
              )}
              <SaveIcon />
            </ToggleButton>
          </Tooltip> */}
          <Tooltip title="How-to help guide" placement="top-start" arrow>
            <ToggleButton
              value="help"
              className={`${classes.button} ${classes.info}`}
              onClick={handleHelpOpen}
            >
              <HelpOutlineIcon className={classes.white} />
            </ToggleButton>
          </Tooltip>
        </ToggleButtonGroup>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    newCoords: state.newCoords.newCoords,
    map: state.map.map,
    show_helper: state.auth.show_helper,
    temp_id: state.newCoords.temp_id,
    color: state.colorpicker.color,
    opened: state.colorpicker.opened,
    instrument: state.instruments.instrument,
    user: state.auth,
    submissionId: state.coords.submissionId,
  }
}

const mapDispatchToProps = {
  instrumentsAction,
  removeLastItemAction,
  addMarkAction,
  removeTempMarkAction,
  getAllMarksForMapAction,
  openColorPickerAction,
  closeColorPickerAction,
  hideHelperAction,
}
export default connect(mapStateToProps, mapDispatchToProps)(DrawerInstruments)
